module.exports = __webpack_public_path__ + "static/media/performance.9d6df98e.svg";